import { withIdentity } from "flavours/glitch/identity_context";
import PropTypes from "prop-types";
import { PureComponent } from "react";

import { defineMessages, FormattedMessage, injectIntl } from "react-intl";

import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";

import { openModal } from "flavours/glitch/actions/modal";
import { fetchServer } from "flavours/glitch/actions/server";
import { Icon } from "flavours/glitch/components/icon";
import { sso_redirect } from "flavours/glitch/initial_state";
import { logOut } from "flavours/glitch/utils/log_out";

import { AccountMenu } from "./account_menu";

const messages = defineMessages({
  logoutMessage: { id: "confirmations.logout.message", defaultMessage: "Are you sure you want to log out?" },
  logoutConfirm: { id: "confirmations.logout.confirm", defaultMessage: "Log out" },
});

const mapDispatchToProps = (dispatch, { intl }) => ({
  dispatchServer() {
    dispatch(fetchServer());
  },

  onLogout () {
    dispatch(openModal({
      modalType: "CONFIRM",
      modalProps: {
        message: intl.formatMessage(messages.logoutMessage),
        confirm: intl.formatMessage(messages.logoutConfirm),
        closeWhenConfirm: false,
        onConfirm: () => logOut(),
      },
    }));
  },
});

class Header extends PureComponent {

  static propTypes = {
    location: PropTypes.object,
    dispatchServer: PropTypes.func,
    onLogout: PropTypes.func,
    intl: PropTypes.object.isRequired,
  };

  componentDidMount () {
    const { dispatchServer } = this.props;
    dispatchServer();
  }

  render () {
    const { signedIn } = this.props.identity;

    let content;

    if (signedIn) {
      content = <AccountMenu onLogout={this.props.onLogout} />;
    } else {

      if (sso_redirect) {
        content = (
          <a href={sso_redirect} data-method='post' className='button button--block button-tertiary'><FormattedMessage id='sign_in_banner.sso_redirect' defaultMessage='Login or Register' /></a>
        );
      } else {
        content = (
          <>
            <a href='/login.html' className='button button-tertiary'><FormattedMessage id='sign_in_banner.sign_in' defaultMessage='Login' /></a>
          </>
        );
      }
    }

    return (
      <div className='ui__header'>
        <Link to='/' className='ui__header__logo'>
          <Icon id='gts-simple' />
        </Link>

        <div className='ui__header__links'>
          {content}
        </div>
      </div>
    );
  }

}

export default withIdentity(injectIntl(withRouter(connect(null, mapDispatchToProps)(Header))));
